
import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { composeClassName } from '../../utils/common.js';
import withMessage from '../../withMessage.jsx';
import { createMessage } from '../../messageHelpers.js';

const TIME_BEFORE_SPINNER_LAUNCH = 1e3;

class VisitorMessage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isShowSpinner: false,
    };

    this.waitingToTurnSpinner = null;
    this.runWaitingSpinner();
  }

  componentWillUnmount() {
    clearTimeout(this.waitingToTurnSpinner);
  }

  runWaitingSpinner() {
    const { isFake } = this.props;

    if (isFake) {
      this.waitingToTurnSpinner = setTimeout(() => {
        if (isFake) {
          this.setState({
            isShowSpinner: true,
          });
        }
      }, TIME_BEFORE_SPINNER_LAUNCH);
    }
  }

  render() {
    const { isShowSpinner } = this.state;
    const {
      nickname, renderText, type, messageTime, isFirstInGroup, isLastInGroup, lastEditedTimeComponent,
    } = this.props;

    return (
      <div className={composeClassName(type, isFirstInGroup, isLastInGroup)}>
        {
          isFirstInGroup
          && (
            <>
              <p className="author">
                {nickname}
              </p>
                {messageTime}
            </>
          )
        }

        <span className="message-text-wrapper">

          <div className="message-text">
            {renderText ? renderText('p') : createMessage(this.props).renderText('p')}
            {lastEditedTimeComponent}
          </div>

          {
            isShowSpinner
            && (
            <svg className="spinner" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 75 75"> {/* TODO: вынести в отдельный файл */}
              <defs>
                <linearGradient id="a" x1="37.5" y1="75" x2="37.5" gradientUnits="userSpaceOnUse">
                  <stop offset=".1" />
                  <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="b" y1="37.5" x2="41.25" y2="37.5" gradientUnits="userSpaceOnUse">
                  <stop offset="0" />
                  <stop offset="1" />
                </linearGradient>
              </defs>
              <path d="M37.5 0A37.5 37.5 0 1 0 75 37.5 37.5 37.5 0 0 0 37.5 0zm0 67.5a30 30 0 1 1 30-30 30 30 0 0 1-30 30z" fill="url(#a)" />
              <path d="M37.5 0a37.5 37.5 0 0 0 0 75v-7.5a30 30 0 0 1 0-60 3.8 3.8 0 0 0 3.8-3.7A3.8 3.8 0 0 0 37.5 0z" fill="url(#b)" />
            </svg>
            )
          }
        </span>
      </div>
    );
  }
}

if (process.env.NODE_ENV !== 'production') {
  VisitorMessage.propTypes = {
    nickname: PropTypes.string.isRequired,
    isFirstInGroup: PropTypes.bool.isRequired,
    isLastInGroup: PropTypes.bool.isRequired,
    renderText: PropTypes.func.isRequired,
    isFake: PropTypes.bool,
    messageTime: PropTypes.node,
    lastEditedTimeComponent: PropTypes.node,
    type: PropTypes.string,
  };
}

export default withMessage(VisitorMessage);
